import SectionDividerWithIcon from './SectionDividerWithIcon';

export default SectionDividerWithIcon;
